module.exports = __webpack_public_path__ + "img/box-bg-desc.69eefa09.png";